export default __webpack_public_path__ + "static/media/654.2e56781c.png";